<template>
<ItpButton
  :type="type"
  :form="form"
  :text="text"
  :icon="icon"
  :variant="variant"
  :spinning="poller.isRunning"
  :disabled="disabled"
  :size="size"
  :tooltip="tooltip"
  :block="block"
  :dropdownItem="dropdownItem"
  dropdown-stays-open-on-click
  class="async-command"
  v-if="loaded"
  @click.prevent.stop="evh_7315092382398562_clickPreventStop($event, {})"
>
</ItpButton>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class AsyncCommand extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  getPoller(...args: any[]) {
    if (!this._poller) {
      this._poller = new this.$app.helpers.AsyncCommandPoller(
        this.$app,
        this.handleError.bind(this),
        (data) => this.$emit('completed', data)
      );
    }
    return this._poller
  }

  beforeDestroy(...args: any[]) {
    { { this.poller && this.poller.stop() } }
  }

  submit(...args: any[]) {
    const [event] = args;

    event.originalEvent.preventDefault();
    event.originalEvent.stopPropagation();

    if (this.poller.isRunning) {
      return false;
    }

    this.poller.begin(
      Promise
        .resolve(_.isFunction(this.payload) ? this.payload() : this.payload)
        .then(payload => {
          if (!payload || payload.cancel) {
            return;
          }
          return this.$app.connections
            .request(this.operation, { content: payload })
            .then(resp => resp.data)
        })
    )
  }

  @Prop({
    type: String,
  })
  icon!: string;

  @Watch('icon')
  onIcon(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("icon")
  }

  @Prop({
    required: true,
    type: String,
  })
  text!: string;

  @Watch('text')
  onText(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("text")
  }

  @Prop({
    required: true,
    type: String,
  })
  operation!: string;

  @Watch('operation')
  onOperation(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("operation")
  }

  @Prop({
    required: true,
  })
  payload!: Function;

  @Watch('payload')
  onPayload(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("payload")
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  dropdownItem!: boolean;

  @Watch('dropdownItem')
  onDropdown_item(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("dropdownItem")
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  block!: boolean;

  @Watch('block')
  onBlock(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("block")
  }

  @Prop({
    type: String,
  })
  variant!: string;

  @Watch('variant')
  onVariant(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("variant")
  }

  @Prop({
    type: Boolean,
  })
  disabled!: boolean;

  @Watch('disabled')
  onDisabled(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("disabled")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  @Prop({
    type: String,
  })
  tooltip!: string;

  @Watch('tooltip')
  onTooltip(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("tooltip")
  }

  @Prop({
    type: Number,
    default: 1000,
  })
  pollingInterval!: number;

  @Watch('pollingInterval')
  onPolling_interval(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("pollingInterval")
  }

  @Prop({
    type: String,
  })
  type!: string;

  @Watch('type')
  onType(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("type")
  }

  @Prop({
  })
  form!: any;

  @Watch('form')
  onForm(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("form")
  }

  poller!: any;

  async $$load_poller() {
    return this.getPoller()
  }

  ux!: any;
  dataMembers = ['poller', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        poller: null,
        ux: null,
      },
    }
  }

  async act_7315092382398562_script_3352_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_7315092382398562_script_3352, alias=undefined
    this.submit($event)
  }

  async act_7315092382398562_script_3352_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7315092382398562_script_3352, alias=undefined
    return {
      value: () => this.act_7315092382398562_script_3352_getActionArgs_value($event),
    }
  }

  async evh_7315092382398562_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_script_3352: actions.ScriptAction;
    evh_7315092382398562_clickPreventStop_3351: actions.EventHandlerImpl;
    evh_7315092382398562_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_script_3352 = new actions.ScriptAction(
      {
        actionArgs: this.act_7315092382398562_script_3352_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_clickPreventStop_3351 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_script_3352,
        event: "click.prevent.stop",
        displayName: "script",
      }
    );
    const evh_7315092382398562_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_clickPreventStop_3351],
      }
    );
    return {
      act_7315092382398562_script_3352,
      evh_7315092382398562_clickPreventStop_3351,
      evh_7315092382398562_clickPreventStop,
    }
  }
}

Vue.component("AsyncCommand", AsyncCommand);

</script>